import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './PropertyManagement.css';

const CompetitorAnalysis: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const savedVolume = localStorage.getItem('videoVolume');
    if (savedVolume !== null) video.volume = parseFloat(savedVolume);

    const handleVolumeChange = () => {
      localStorage.setItem('videoVolume', String(video.volume));
    };
    video.addEventListener('volumechange', handleVolumeChange);
    return () => video.removeEventListener('volumechange', handleVolumeChange);
  }, []);

  return (
    <div className="re-page">
      <div className="re-bg">
        <div className="re-nebula re-nebula-1" />
        <div className="re-nebula re-nebula-2" />
        <div className="re-nebula re-nebula-3" />
      </div>

      <div className={`re-content ${isVisible ? 'visible' : ''}`}>
        <nav className="re-nav">
          <Link to="/property-management" className="re-back">
            ← Back to Property Management
          </Link>
        </nav>

        <section className="re-hero">
          <h1 className="re-headline">Demo: Competitor analysis</h1>
        </section>

        <section className="re-case-study">
          <div className="re-video-wrapper">
            <video
              ref={videoRef}
              className="re-video"
              src="/videos/competitor_analysis_demo.mp4"
              autoPlay
              loop
              muted
              playsInline
              controls
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <p className="re-demo-desc">Automated reports tracking rents, concessions, and availability across competing buildings in your market.</p>
          <Link
            className="re-download-btn"
            to="/property-management/sample-competitor-analysis-report"
          >
            Open report
          </Link>
        </section>
      </div>
    </div>
  );
};

export default CompetitorAnalysis;
